var base = require('../product/base');
const { isMobile } = require('../utilities/breakpoints');

module.exports = function () {
    base.basketQuantityChange();
    base.basketRemoveProduct();
}

$(document).ready(function () {
    // Duplicate mini cart in sticky header
    var miniCartHTML = $('#shopping-cart .js-minicart').html()
    $('.ico-basket-mobile .js-minicart').html(miniCartHTML);

    function quantitySelector() {
        $('.min-cart-content .quantity-button').on('click', function () {
            var oldValue, maxValue, newVal;
            var pid = ($(this).attr("data-pid"));
            var traductionText = $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').data('text');
            $.spinner().start();
        
            if (!pid){
                oldValue = $(".min-cart-content #quantity option:selected").text();
                maxValue = parseInt($('.min-cart-content #quantity option:last').val());

            
                if (this.id == "quantity-plus") {    
                    newVal = parseFloat(oldValue) + 1;
                    $(".min-cart-content #quantity option[value='"+newVal+"']").prop('selected', true);
                    $(".min-cart-content #quantity option[value='"+newVal+"']").text(newVal);
                    $('.min-cart-content #quantity-minus').prop('disabled', false);
                    if (oldValue >= maxValue - 1) {
                        $('.min-cart-content #quantity-plus').prop('disabled', true);
                    }
                } else {
                    if (oldValue > 0) {
                        newVal = parseFloat(oldValue) - 1;
                        $(".min-cart-content #quantity option[value='"+newVal+"']").prop('selected', true);
                        $(".min-cart-content #quantity option[value='"+newVal+"']").text(newVal);
                        $('.min-cart-content #quantity-plus').prop('disabled', false);
                        if (oldValue <= 2) {
                            $('.min-cart-content #quantity-minus').prop('disabled', true);
                        }
                    } else {
                        newVal = 0;
                    }
                }
                $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').text(traductionText + ' ' + newVal);
            } else {
                pid = ($(this).attr("data-pid"));
                oldValue = parseInt($('.min-cart-content .quantity[data-pid='+pid+'] option:selected').text());
                maxValue = parseInt($('.min-cart-content .quantity[data-pid='+pid+'] option:last').val());

                if (this.id === 'quantity-plus') {
                    newVal = parseFloat(oldValue) + 1;
                    $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").prop('selected', true);
                    $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").val(newVal).change();
                    $('.min-cart-content #quantity-minus[data-pid='+pid+']').prop('disabled', false);
                    if (oldValue >= maxValue) {
                        $('.min-cart-content #quantity-plus[data-pid='+pid+']').prop('disabled', true);
                        $.spinner().stop();
                    }
                } else {
                    if (oldValue > 0) {
                        newVal = parseFloat(oldValue) - 1;
                        $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").prop('selected', true);
                        $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").val(newVal).change();
                        $('.min-cart-content #quantity-plus[data-pid='+pid+']').prop('disabled', false);
                        if (oldValue <= 2) {
                            $('.min-cart-content #quantity-minus[data-pid='+pid+']').prop('disabled', true);
                            $.spinner().stop();
                        }
                    } else {
                        newVal = 0;
                    }
                }
                $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').text(traductionText + ' ' + newVal);
            }
        });
    }

    document.addEventListener('keydown', function (e) {
        const miniCartClose = document.getElementById('mini-cart-close-expanded')
        const lastbuttonCart = document.querySelector('.lastbutton-cart')
        const checkoutCartButton = document.getElementById('checkout-cart-button')

        if (e.target === lastbuttonCart) {
            //if target is log on button, check for key(s) pressed.
            //if keys are "shift" and "tab":
            //Focus on password text box.
            if (e.shiftKey && e.keyCode === 9) {
                e.preventDefault()
                checkoutCartButton.focus()
            } else if (e.keyCode === 9) {
                e.preventDefault();
                miniCartClose.focus()
            }
        } else if (e.target === miniCartClose) {
            //If target is user name text box, check for keys pressed.
            //if keys are "shift" and "tab":
            //Focus on log on button.
            if (e.shiftKey && e.keyCode === 9) {
                e.preventDefault()
                lastbuttonCart.focus()
            }
        }
    });

    $('.js-minicart').on('count:update', function (event, count) { // eslint-disable-line no-unused-vars
        if (count && !Number.isNaN(count.quantityTotal)) {
            $('.js-minicart .minicart-quantity').text(count.quantityTotal);
        }
    });

    $(document).on('click', '.js-minicart-desktop, .js-minicart-mobile', function () {
        var url;
        if (isMobile()) {
            url = $('.js-minicart-mobile').data('action-url');
        } else {
            url = $('.js-minicart-desktop').data('action-url');
        }

        var count = parseInt($('.js-minicart .minicart-quantity').text(), 10);
        $('html, body').addClass('disable_scrolling_minicart');
        
        if (isMobile()) {
            $('.js-minicart-mobile').attr('aria-expanded', 'true');
        } else {
            $('.js-minicart-desktop').attr('aria-expanded', 'true');
        }
        if ($('.js-minicart .popover.show').length === 0) {
            $('.mini-cart-overlay').show();
            if (count == 0) {
                $('#cart-empty').show();
                $('.mini-cart-overlay').show();
                $.spinner().stop();
            } else {
                $('.js-minicart .popover').spinner().start();
                $('.mini-cart-overlay').show();
                $.get(url, function (data) {
                    if (data) {
                        var dataDiv = document.createElement('div');
                        dataDiv.innerHTML = data;
                        $('.js-minicart .popover').empty();
                        $('.js-minicart .popover').append(dataDiv);
                    }
                    quantitySelector();
                    $.spinner().stop();
            
                    if (isMobile()) {
                        $('.js-minicart-mobile').focusout();
                    } else {
                        $('.js-minicart-desktop').focusout();
                    }
                    $('#mini-cart-close-expanded').trigger('focus');
                });
            }
            $('.js-minicart .popover').show();
            $('.popover .mini-cart-close').focus();
            $('#search-desktop-area').removeClass('show');
        }
    });

    $(document).ready(function () {
        var dialog = $('.min-cart-content');
        var dialogElements = dialog.find(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        dialogElements.last().on('keydown', function (e) {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();
                dialogElements.first().focus();
            }
        });

        dialogElements.first().on('keydown', function (e) {
            if (e.key === 'Tab' && e.shiftKey) {
                e.preventDefault();
                dialogElements.last().focus();
            }
        });
    });

    // hide back-to-top-button in minicart mobile device.
    $(document).on('mouseenter focusin', '.js-minicart', function () {
        if (isMobile()) {
            $('.back-to-top-button').hide();
        }
    });

    $('body').on('click', function (e) {
        if ($('.js-minicart').has(e.target).length <= 0) {
            $('.js-minicart .popover').hide();
            $('.mini-cart-overlay').hide();
        }
    });

    $('body').on('change', '.js-minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });
});

$(document).ready(function () {
    $(document).on('click', '.mini-cart-close, .mini-cart-overlay, #continue-shopping-button, #continue-empty-shopping-button, .mini-cart-close-button', function () {
        $('.mini-cart-overlay').hide();
        $('.js-minicart .popover').hide();
        $('html, body').removeClass('disable_scrolling_minicart');
        $('.mini-cart-close').focusout();
        if (isMobile()) {
            $('.js-minicart-mobile').attr('aria-expanded', 'false');
            $('.js-minicart-mobile').focus();
        } else {
            $('.js-minicart-desktop').attr('aria-expanded', 'false');
            $('.js-minicart-desktop').focus();
        }
    });

    $(document).keyup(function(e) {
        if (e.keyCode === 27) {
            if (isMobile()) {
                if ($(".js-minicart-mobile").first().attr('aria-expanded') === 'true') {
                    $('.mini-cart-close').trigger('click');
                }
            } else {
                if ($(".js-minicart-desktop").first().attr('aria-expanded') === 'true') {
                    $('.mini-cart-close').trigger('click');
                }
            }
        }
    });
    
    var popupElement = document.querySelector(".popover");
    if (popupElement) {
        popupElement.addEventListener('focusout', function (event) {
            if (popupElement.contains(event.relatedTarget)) {
                return;
            }
            $('#mini-cart-close-expanded').focus();
        });
    }

    $(document).on('click', '#btnShowCart', function () {
        var url = $('#btnShowCart').data('target');
        window.location.href = url;
        return false;
    });

    $(document).on('click', '#continue-shopping-button', function () {
        $('.popover-bottom').removeClass('d-block');
    });

});
